import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Drawer from '@material-ui/core/Drawer';
import faker from '@faker-js/faker';

import { withOffset } from 'Context/LayoutContext';

import { Box, Flex, Text } from '../../Base';

const Divider = styled(Box)`
  border: 1px solid ${({ theme }) => theme.colors.greyscale.grey4};
  margin: 10px;
`;

const MenuItem = styled(Flex)`
  height: 52px;
  align-items: center;
  cursor: pointer;

  &:hover {
    color: ${({ theme }) => theme.colors.text};
  }
  &:active {
    background-color: ${({ theme }) => theme.colors.greyscale.grey3};
  }
`;

const MenuList = ({ menuItems, onMenuItemClick }) => {
  return menuItems.map((item, index) => {
    const { leftAdornment, rightAdornment, active, text, renderCustomMenuItem, name } = item || {};
    const isCustomMenuItem = typeof renderCustomMenuItem === 'function';
    const dataTestIdPrefix = name ? `sidebar-mycourse-${name}` : 'sidebar-mycourse';
    if (item.name === 'divider') {
      return <Divider />;
    }
    return (
      <MenuItem
        as={'a'}
        color={'text'}
        px={6}
        key={text}
        onClick={isCustomMenuItem ? undefined : (event) => onMenuItemClick(event, index, item)}
        data-testid={`menu-${dataTestIdPrefix}`}
      >
        {leftAdornment}
        {isCustomMenuItem ? (
          renderCustomMenuItem()
        ) : (
          <Text
            textStyle={'heading5'}
            fontWeight={'bold'}
            pr={3}
            color={active ? 'primary' : 'inherit'}
          >
            {text}
          </Text>
        )}
        {rightAdornment}
      </MenuItem>
    );
  });
};

const MenuContainer = styled(Flex)`
  position: relative;
  flex-direction: column;
  justify-content: flex-start;
  flex-grow: 1;
  width: calc(6 / 7 * 100vw);
  max-width: 375px;
  height: 100%;
`;

const Avatar = styled(Flex)`
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  width: 40px;
  height: 40px;
`;

const SideMenu = ({
  menuItems,
  onMenuItemClick,
  open,
  onClose,
  avatarText,
  title,
  header,
  headerContent,
  footer,
  name,
}) => {
  return (
    <Drawer open={open} onClose={onClose}>
      <MenuContainer id="side-menu-container">
        {header && (
          <Box
            pt={'APP_TOP_OFFSET'}
            pb={5}
            px={4}
            mb={6}
            bg={'coolGrey.grey3'}
            style={{ flexShrink: 0 }}
          >
            <Avatar mt={8} mb={4} bg={'primary'} data-testid={`avatar-${name}-header`}>
              <Text textStyle={'subtitle1'} color={'white'}>
                {avatarText}
              </Text>
            </Avatar>
            <Text textStyle={'heading2'} mb={'28px'} data-testid={`text-${name}-header-title`}>
              {title}
            </Text>
            {headerContent}
          </Box>
        )}
        <Box style={{ flexGrow: 1 }}>
          {menuItems && menuItems.length > 0 && (
            <MenuList menuItems={menuItems} onMenuItemClick={onMenuItemClick} />
          )}
        </Box>
        {footer && (
          <Box mt={7} style={{ flexShrink: 0 }}>
            {footer}
          </Box>
        )}
      </MenuContainer>
    </Drawer>
  );
};

SideMenu.propTypes = {
  open: PropTypes.bool,
  menuItems: PropTypes.array,
  onMenuItemClick: PropTypes.func,
  avatarText: PropTypes.string,
  title: PropTypes.string,
  footer: PropTypes.node,
  header: PropTypes.bool,
  headerContent: PropTypes.node,
  appConfig: PropTypes.object,
  name: PropTypes.string,
};

SideMenu.defaultProps = {
  open: false,
  onClose: () => {},
  menuItems: [],
  onMenuItemClick: () => {},
  name: faker.random.uuid(),
};

export default withOffset(SideMenu);
